export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      serviceRssSetting: {
        serviceRssId: 3,
        serviceRssUuid: "servicerss003",
        rssName: "地域のお知らせ",
        rssURL: "https://xxxxx.xxxxx.xxx"
      }
    }
  }
}